import { DELIVERY_TYPE_OPTIONS } from 'src/models/delivery-type/DeliveryType'
import { fastPrepMinutes } from 'src/models/location/Location'

/**
 * Computer that computes available Delivery Type options for a given Item on a given Order.
 */
class ItemDeliveryTypeOptionsComputer {
  static #instance = null

  constructor () {
    if (!ItemDeliveryTypeOptionsComputer.#instance) {
      ItemDeliveryTypeOptionsComputer.#instance = this
    }
    return ItemDeliveryTypeOptionsComputer.#instance
  }

  deliveryTypeOptions (item, order) {
    const options = []

    const context = item?.context || order?.context
    const registerStation = context?.currentRegisterClient?.registerStation
    const registerType = registerStation?.registerType
    const allowRegisterDeliveryType = registerType && registerType?.allowRegisterDeliveryType !== false
    const itemColocatedWithRegister = item?.hasLocation?.(registerType?.location)

    // See if we can do more direct handoffs. If not, then delivery is required
    if (!item?.requiresPreparation) {
      // For online orders (orders without a register type), ready to serve
      // items should default to collect from register.
      if (_.isNil(registerType)) {
        options.push({
          value: DELIVERY_TYPE_OPTIONS.COLLECT_FROM_REGISTER,
          label: _.startCase(DELIVERY_TYPE_OPTIONS.COLLECT_FROM_REGISTER)
        })
      // Employee can hand directly to customer
      } else if (itemColocatedWithRegister && order?.deliverReadyToServeItems === false) {
        options.push({
          value: DELIVERY_TYPE_OPTIONS.DIRECT_TO_CUSTOMER,
          label: _.startCase(DELIVERY_TYPE_OPTIONS.DIRECT_TO_CUSTOMER)
        })
      // Ready to serve, but needs to come from a different location, does that
      // location support delivery of RTS items?
      } else if (allowRegisterDeliveryType && item?.primaryLocationForRegisterStation?.(registerStation)?.deliverReadyToServeItemsToRemoteRegisters) {
        options.push({
          value: DELIVERY_TYPE_OPTIONS.REGISTER,
          label: _.startCase(DELIVERY_TYPE_OPTIONS.REGISTER)
        })
      }
    // Requires preparation
    } else {
      const fastPrepEligable = order?.deliverFastPrepItems === false && item?.preparationTimeMinutes <= fastPrepMinutes

      const isFastPrepForLocalRegister = (itemColocatedWithRegister && registerType?.location?.deliverFastPrepItemsToLocalRegisters)
      const isFastPrepForRemoteRegister = isFastPrepForLocalRegister || (!itemColocatedWithRegister && item?.primaryLocationForRegisterStation?.(registerStation)?.deliverFastPrepItemsToRemoteRegisters)

      if (allowRegisterDeliveryType && fastPrepEligable && (isFastPrepForLocalRegister || isFastPrepForRemoteRegister)) {
        options.push({
          value: DELIVERY_TYPE_OPTIONS.REGISTER,
          label: _.startCase(DELIVERY_TYPE_OPTIONS.REGISTER)
        })
      }
    }

    return [...options, ...(order?.deliveryTypeOptions || [])]
  }
}

const itemDeliveryTypeOptionsComputer = new ItemDeliveryTypeOptionsComputer()
export default itemDeliveryTypeOptionsComputer
